import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { FiberManualRecord } from '@material-ui/icons';

const styles = (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    flexDirection: 'column'
  },
  icon: {
    fontSize: theme.textFontSize,
    color: theme.rowViolationDotColor
  }
});

const DotRenderer = (params) => {
  const { classes, value } = params;
  return (
    <div className={classes.root}>
      {value ? <FiberManualRecord className={classes.icon} /> : ''}
    </div>
  );
};

export default withStyles(styles)(DotRenderer);
